import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const extendedActionMenuDefaultVariants = {}
const extendedActionMenuCompoundVariants = []

const extendedActionMenuSlotNames = [
  [
    "surface",
    "ExtendedActionMenu__surface"
  ],
  [
    "list",
    "ExtendedActionMenu__list"
  ],
  [
    "item",
    "ExtendedActionMenu__item"
  ],
  [
    "iconSlot",
    "ExtendedActionMenu__iconSlot"
  ],
  [
    "icon",
    "ExtendedActionMenu__icon"
  ],
  [
    "body",
    "ExtendedActionMenu__body"
  ],
  [
    "label",
    "ExtendedActionMenu__label"
  ],
  [
    "description",
    "ExtendedActionMenu__description"
  ],
  [
    "dividerWrap",
    "ExtendedActionMenu__dividerWrap"
  ]
]
const extendedActionMenuSlotFns = /* @__PURE__ */ extendedActionMenuSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, extendedActionMenuDefaultVariants, getSlotCompoundVariant(extendedActionMenuCompoundVariants, slotName))])

const extendedActionMenuFn = memo((props = {}) => {
  return Object.fromEntries(extendedActionMenuSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const extendedActionMenuVariantKeys = [
  "tone"
]
const getVariantProps = (variants) => ({ ...extendedActionMenuDefaultVariants, ...compact(variants) })

export const extendedActionMenu = /* @__PURE__ */ Object.assign(extendedActionMenuFn, {
  __recipe__: false,
  __name__: 'extendedActionMenu',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: extendedActionMenuVariantKeys,
  variantMap: {
  "tone": [
    "critical"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, extendedActionMenuVariantKeys)
  },
  getVariantProps
})